import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down-wall"} maskId="square-filled-radius-0-stroke-1-IconArrowDownWall"><path d="M12.5 19.293L17 14.793L17.707 15.5L12 21.207L6.29297 15.5L7 14.793L11.5 19.293V7H12.5V19.293Z" fill="currentColor"/><path d="M20 4H4V3H20V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDownWall;
